import React, { useState } from 'react'
import { Box, Grid, Stack, Typography, IconButton } from '@mui/material';
import { useNavigate } from "react-router-dom";
// icons
import AngleRightIcon from "common/customIcons/angle_right";
// utils and helpers
import { formatTimestampToDateView } from "utilities/common";
import { kitRefillLogs } from "../../../../redux/slices/hyperwolf/inventoryDistribution";
// custom components
import CommonLayout from 'layouts/DashboardLayout'
import AgGridAccordionTable from "components/tables/AgGridAccordionTable";
import { DateFilter } from "common/filters";

const RefillActivityLogs = () => {
  const navigate = useNavigate();

  const [refreshTable, setRefreshTable] = useState(false)
  const [customFilters, setCustomFilters] = useState({});

  const columnDefs = [
    {
      headerName: 'Refill',
      field: 'refillLabel',
      suppressMenu: false,
      minWidth: 400,
      sortable: false,
      className: 'field-region',
      valueGetter: ({ data }) => `${data?.refillLabel || '-'} (${data?.distributionType || '-'})`
    },
    {
      headerName: 'Qty',
      field: 'qty',
      suppressMenu: false,
      sortable: false,
      className: 'field-closing-hour',
    },
    {
      headerName: 'Updated By',
      field: 'updatedBy',
      suppressMenu: false,
      sortable: false,
      className: 'field-total-product',
    },
  ];

  const expandedColumnDefs = [
    {
      headerName: 'Refill',
      field: 'refillLabel',
      suppressMenu: false,
      flex: 1.5,
      minWidth: 220,
      sortable: false,
      valueGetter: ({ data }) => `${data?.refillLabel || '-'} (${data?.distributionType || '-'})`
    },
    {
      headerName: 'Qty',
      field: 'totalQty',
      suppressMenu: false,
      flex: 0.75,
      minWidth: 100,
      sortable: false,
    },
    {
      headerName: 'Deleted By',
      field: 'deletedBy',
      suppressMenu: false,
      flex: 1.25,
      minWidth: 180,
      sortable: false,
    },
    {
      headerName: 'Deleted At',
      field: 'deletedAt',
      suppressMenu: false,
      flex: 1.25,
      minWidth: 200,
      sortable: false,
      cellStyle: { textAlign: 'right', justifyContent: 'end' },
      headerClass: 'right-aligned-cell-header',
      valueGetter: ({ data }) => data?.deletedAt ? formatTimestampToDateView(data.deletedAt) : "-"
    },
  ];

  const handleDateChange = async (values) => {
    setCustomFilters(prev => ({ ...prev, ...values }));
    setRefreshTable(prev => !prev)
  }

  return (
    <CommonLayout>
      <Box p={{ xs: 2, sm: 3, lg: 4 }}>
        <Grid container alignItems="center" rowSpacing={2} columnSpacing={2} mb={3}>
          <Grid item xs={12} sm={4}>
            <Box display="flex" alignItems="center" color="text.main" lineHeight={1}>
              <IconButton onClick={() => navigate(-1)}>
                <AngleRightIcon fontSize="14px" />
              </IconButton>
              <Typography variant='h4' fontWeight="semibold" ml={0.75}>Activity Logs</Typography>
            </Box>
          </Grid>

          <Grid item xs={12} sm={8}>
            <Stack direction="row" justifyContent={{ xs: 'start', sm: 'end' }} flexWrap="wrap" alignItems="stretch" gap={2} className="btn-filter-icon">
              {/* Date Filter */}
              <DateFilter handleChange={handleDateChange} />
            </Stack>
          </Grid>
        </Grid>

        {/* Listing */}
        <div className="cus-distributions-table">
          <AgGridAccordionTable
            tableName="Refill Activity Logs"
            columnDefs={columnDefs}
            expandedColumnDefs={expandedColumnDefs}
            getDataMethod={kitRefillLogs}
            refreshTable={refreshTable}
            customFilters={customFilters}
          />
        </div>
      </Box>
    </CommonLayout>
  )
}

export default RefillActivityLogs
